import { render, staticRenderFns } from "./Carousels.vue?vue&type=template&id=260408de&scoped=true&"
import script from "./Carousels.vue?vue&type=script&lang=js&"
export * from "./Carousels.vue?vue&type=script&lang=js&"
import style0 from "./Carousels.vue?vue&type=style&index=0&id=260408de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "260408de",
  null
  
)

export default component.exports